import "./style.scss";

import Button, { Button_Style, Button_Type } from "shared/ui/Button/Button";
import { FC, useContext } from "react";

import { DocumentBasylic } from "shared/types/types";
import Loader from "shared/ui/Loader";
import ShareID from "@shareid/sdk-launcher";
import { UserContext } from "features/account";
import {getVerificationResult} from "features/analysis";
import {formatShareIDVideoResultToDocument} from "../../utils/utils";
import { consumeDetection, DetectionTool } from "features/credits";

type ShareIDVerificationProps = {
    accessToken: string;
    applicantId?: string;
    setIsScanning?: any;
    setIsScanningLoadingText?: any;
    setIsScanned?: any;
    setErrorType?: any;
    setDocument?: any;
    errorType?: any;
    setIsShareID: any;
    generateURLWithShareIdVideo: any;
};

const ShareIDVerification: FC<ShareIDVerificationProps> = ({
    accessToken,
    applicantId,
    setIsScanning,
   setIsScanningLoadingText,
    setIsScanned,
    setErrorType,
    setDocument,
    errorType,
    setIsShareID,
    generateURLWithShareIdVideo
}) => {
    const { user } = useContext(UserContext);
    const userType = user?.type;
    let progress = 0;

    // NB : la fonction `addClassToShareID` a été SUPPRIMÉE avec la migration vers
    // `@shareid/sdk-launcher`. Elle manipulait le DOM interne du SDK par positions
    // fixes (`children[0].children[0]…`) pour y poser des classes en `display: none` ;
    // sur le nouveau paquet ces positions désignent d'autres éléments, et elle
    // masquait donc le composant entier. L'habillage se fait désormais uniquement
    // en CSS (`style.scss`), ancré sur des classes du SDK. Voir CLAUDE.md.

    const getDataFromUID = async () => {
        setIsScanning && setIsScanning(true);
        progress += 1;

        if (progress <= 3) { // à la 15e seconde
            setIsScanningLoadingText("Analyse du document en cours...");
        } else if (progress <= 5) { // à la 25e seconde
            setIsScanningLoadingText("Vérification des informations principales...");
        } else if (progress <= 7) { // à la 35e seconde
            setIsScanningLoadingText("Contrôle des bases de données sécurisées...");
        } else if (progress <= 9) { // à la 45e seconde
            setIsScanningLoadingText("Recherche d'éventuelles anomalies...");
        } else if (progress <= 11) { // à la 55e seconde
            setIsScanningLoadingText("Finalisation de l'analyse...");
        } else if (progress >= 12){
            setIsScanningLoadingText("C'est presque terminé, merci de patienter...");
        }
        if (!userType) return;
        try {
            const response = await getVerificationResult(userType, applicantId);

            if (response.data.documentAnalyse.document.ocr != null) {
                await consumeDetection(userType, DetectionTool.documentVerify); //3 gratuites/mois, puis 1 vérification débitée
            }

            if (response.data.documentAnalyse.document == null || response.data.documentAnalyse.document.ocr == null) {
                setIsScanned && setIsScanned(true);
                setIsScanning && setIsScanning(false);
                setErrorType && setErrorType({ status: 400, message: "une erreur s'est produite" });
            } else if (response.status === 200) {
                if (user?.type === "partner") {
                    if (response) {
                        generateURLWithShareIdVideo(response.data?.documentAnalyse, applicantId);
                    }
                }
                setIsScanned && setIsScanned(true);
                setDocument && setDocument(formatShareIDVideoResultToDocument(response.data.documentAnalyse));
                setIsScanning && setIsScanning(false);
            }
        } catch (error: any) {
            // console.error("Une erreur s'est produite :", error);
            if (error.response.status === 404 && errorType?.status !== 400) {
                setTimeout(() => getDataFromUID(), 5000);
            }
        }
    };
    return (
        <div className="IDVerify">
            {accessToken ? (
                <ShareID
                    debug={true}
                    token={accessToken}
                    language="fr"
                    onFail={(data: any) => {
                        console.log("verification failed : ", data);
                    }}
                    onSuccess={(data: any) => {
                        getDataFromUID();
                    }}
                    onExit={(data: any) => console.log("exit", data)}
                    // ⚠️ RUPTURE `sdk-launcher` : le thème est simplifié à deux couleurs
                    // (`main` / `mainText`) ; l'ancien `primary: {active, hover, disabled}`
                    // n'existe plus. `main` reprend notre bleu de marque (ex-`active`) ;
                    // `mainText` = couleur du texte posé dessus (blanc, à valider visuellement).
                    theme={{
                        colors: {
                            main: "#1956A8",
                            mainText: "#FFFFFF",
                        },
                    }}
                    //redirectUrl="https://www.basylic.com"
                />
            ) : (
                <Loader />
            )}
            {/*<div className="">
                <p className="mb-2 text-center">Vous n'avez pas le document d'identité sur vous ?</p>
                <Button
                    type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                    style={Button_Style.OUTLINED}
                    label="Utiliser un scan du document"
                    onClick={() => setIsShareID(false)}
                    className="m-auto"
                />
            </div>*/}
        </div>
    );
};

export default ShareIDVerification;
